<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="true"
    :backButtonRoute="backButtonRoute"
    ref="goods-in-review"
    :data-model="dataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :paging="false"
    class="goods-in-review"
    :batchPadding="5"
  >
    <dx-tooltip :ref="CompleteTooltipRefName" position="top">
      <div class="tooltipContent">
        <div>Select to Mark Lines Complete</div>
      </div>
    </dx-tooltip>
  </TransactionTemplate>
</template>
<script>
import TransactionTemplate from "@/templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { GoodsInReviewService } from "@/_services/api/purchasing/goods-in-review.service";
import { FeatureStorage } from "@/_services/storage";
import DxTooltip from "devextreme-vue/tooltip";
import { on } from "devextreme/events";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
    DxTooltip,
  },

  created() {
    this.setLoading = true;
    this.initialized();
  },
  data() {
    return {
      CompleteTooltipRefName: "completeTooltip",
      loaded: false,
      setLoading: false,
      headerEndpoint: undefined,
      isReturnedGoods: false,
      dataModel: {
        Note: undefined,
        DateIn: new Date(),
        DateReceived: new Date(),
        SupplierName: undefined,
        FriendlyStatus: undefined,
        SupplierCurrencyCode: "FX",
      },
      reload: false,
      validationSummary: [],
      ui: {
        DateInMin: null,
        DateInMax: null,
      },
      serverError: {},
      expandChildGrid: false,
      gridDataLoaded: false,
      CollapseBtnContentReady: false,
      IsBatchAvailable: false,
    };
  },
  computed: {
    getScreenJson() {
      return {
        title: "Goods In Review",
        endpoint: {},
        headerData: {
          headerFormVisible: false,
          headerToolbar: {
            audit: true,
            status: false,
            notes: this.isReturnedGoods,
            save: false,
            orderComments: {
              dataField: "Note",
            },
            commentsTitle: "Goods In Return Comments",
            commentItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "Note",
                    editorType: "dxTextArea",
                    editorOptions: {
                      // format: this.getDecimalFormatByCode(6).Format,
                      height: "140",
                      maxLength: 1000,
                    },
                    validationRules: [],
                    label: {
                      text: " ",
                      location: "top",
                    },
                  },
                ],
              },
            ],
          },
          title: {
            // Credit # [CreditNote] for Invoice # [InvoiceNumber]
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: undefined,
                text: "Goods In # " + this.baseView.id,
              },
              secondary: {
                dataField: "PurchaseOrderCode",
                text: " for PO # ",
              },
            },
            secondary: {
              dataField: "SupplierName",
              text: undefined,
            },
          },
        },
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "GoodsInDetail",
              filter: [["GoodsInCode eq " + this.baseView.id]],
              serverPaging: true,
              allowGrouping: false,
              // expand: "SaleItem",
              postProcessCallback: this.PostProcess,
              expand:
                "Product(select=IsManufacturedDateRequired,UseByShelfLife,BestBeforeShelfLife)",
            },
            // noDataMessage: {
            //   // this `review` is one of the options in the grid toolbar dropdown that represents 'Review', 'ProductList' 'CustomerList'
            //   review: {
            //     addNew: {
            //       class: "no-data",
            //       title: "No Credit Lines",
            //       message: "Get Started, Add a Credit Line",
            //     },
            //   },
            // },
            options: {
              onCellPreparedCallBack: this.onCellPreparedCallBack,
              dxPaging: false,
              onContentReadyCallBack: this.onContentReadyCallBack,
              onEditorPreparing: this.onEditorPreparing,
            },
          },
          toolbar: {
            status: true,
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
            review: false,
            audit: true,
            save: false,
            pdf: true,
            note: this.isReturnedGoods,
            // commentsTitle: "",
            email: this.baseView.mode === "review",
            screenName: "Goods In Review",
            // saveCallback: this.saveGoodsIn,
            customButtons: [
              {
                icon: this.expandChildGrid ? "chevronup" : "chevrondown",
                label: this.getLabel,
                clickAction: () => {
                  this.expandMasterDetailsSection();
                },
                buttonLocation: "left",
                elementAttr: {
                  class: "colps-expnd-btn",
                },
                onContentReady: this.onCollapseBtnContentReady,
                visible: this.IsBatchAvailable,
              },
            ],
            form: {
              location: "left",
              items: [
                {
                  dataField: "DateIn",
                  label: {
                    text: "Date",
                  },
                  editorType: "dxDateBox",
                  cssClass: "date-in-container",
                  editorOptions: {
                    displayFormat: "dd MMM yyyy",
                    width: 120,
                    min: this.ui.DateInMin,
                    max: this.ui.DateInMax,
                    disabled: true,
                  },
                  validationRules: [
                    {
                      type: "required",
                      message: "Date is required",
                    },
                  ],
                },
                {
                  dataField: "DateReceived",
                  label: "Date Received",
                  editorType: "dxDateBox",
                  cssClass: "date-in-container",
                  editorOptions: {
                    displayFormat: "dd MMM yyyy",
                    width: 120,
                    disabled: true,
                  },
                  validationRules: [
                    {
                      type: "required",
                      message: "Date Received is required",
                    },
                  ],
                },
              ],
            },
            emailMenuItems: {
              referenceNoFields: [
                {
                  ReportDisplayName: "Purchase Order",
                  ReferenceNoField: "PurchaseOrderCode",
                },
                {
                  ReportDisplayName: "Goods In",
                  ReferenceNoField: "GoodsInCode",
                },
              ],
              // referenceNoField: "PurchaseOrderCode",
              makeDisabled: (dataModel, emailRecords) => {
                const items = [];
                emailRecords.forEach((element) => {
                  items.push({
                    ReportDisplayName: element.ReportDisplayName,
                    ScreenName: element.ScreenName,
                    ScreenLayoutApplicationFeatureCode:
                      element.ScreenLayoutApplicationFeatureCode,
                    TransactionCode: element.TransactionCode,
                    disabled: element.disabled,
                  });
                });
                return items;
              },
            },
            auditItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "FormattedDateCreated",
                    label: { text: "Created By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      // // disabled: true,
                    },
                  },
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Changed By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      // disabled: true,
                    },
                  },
                ],
              },
            ],

            ellipsis: {
              menuItems: [
                {
                  menuText: "Return",
                  disabled: !(
                    FeatureStorage.checkPermission("GoodsReturn", "create") &&
                    this.dataModel.FriendlyStatus === "Open"
                  ),
                },
                {
                  menuText: "Invoice",
                  disabled: !(
                    this.dataModel.FriendlyStatus === "Open" &&
                    FeatureStorage.checkPermission("SupplierInvoice", "create")
                  ),
                },
                {
                  menuText: "Complete",
                  disabled: !(
                    this.dataModel.FriendlyStatus === "Open" &&
                    FeatureStorage.checkPermission("GoodsIn", "create")
                  ),
                },
              ],
              visible: true,
              clickAction: (e) => {
                if (e.itemData.menuText === "Return") {
                  this.toReturn(e);
                } else if (e.itemData.menuText === "Invoice") {
                  this.goToSupplierInvoice(e);
                } else if (e.itemData.menuText === "Complete") {
                  this.markAsComplete(e);
                }
              },
            },
          },

          childColumns: this.getChildColumns,
          columns: [
            {
              screenField: "ProductItem",
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              label: "Product/ Account",
              sortOrder: "asc",
              gridDataField: "ItemCode",
              sortIndex: 0,
              width: "auto",
            },

            {
              screenField: "Branch",
              cellTemplate: undefined,
              gridDataField: "BranchCode",
              width: ColumnWidth.BranchCode.width,
              minWidth: ColumnWidth.BranchCode.minWidth,
            },
            {
              screenField: "Division",
              cellTemplate: undefined,
              gridDataField: "DivisionCode",
              width: ColumnWidth.Division.width,
              minWidth: ColumnWidth.Division.minWidth,
            },
            {
              screenField: "SalesUM",
              dataField: "SupplierUM",
              width: ColumnWidth.UnitOfMeasure.width,
              minWidth: ColumnWidth.UnitOfMeasure.minWidth,
            },
            {
              // screenField: "Tax",
              gridLabel: "Tax",
              dataField: "TaxCode",
              width: ColumnWidth.TaxCode.width,
              minWidth: ColumnWidth.TaxCode.minWidth,
            },
            {
              screenField: "SalesUMFXPrice",
              label: `Unit Price (${this.dataModel.SupplierCurrencyCode})`,
              gridDataField: "SupplierFXPrice",
              format: "Decimal-16-4C",
              allowEditing: false,
              width: ColumnWidth.Price4DecimalPoints.width,
              minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
            },
            {
              screenField: "Ordered",
              dataField: "SupplierRequired",
              format: "Decimal-16-4",
              width: ColumnWidth.Quantity4DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity4DecimalPoints.maxWidth,
              label: "Ordered",
            },

            {
              screenField: "Quantity",
              dataField: "SupplierOutstandingQty",
              format: "Decimal-16-4",
              label: "Outstanding",
              width: ColumnWidth.Quantity4DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity4DecimalPoints.maxWidth,
            },
            {
              screenField: "Quantity",
              dataField: "SupplierReceivedQty",
              label: "Received",
              format: "Decimal-16-4",
              width: ColumnWidth.Quantity4DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity4DecimalPoints.maxWidth,
              // type: "EditableDecimal",
              showEditorAlways: false,
              // makeDisabled: (data) => {
              //   if (
              //     data.data.IsBatchProduct == "No" ||
              //     data.data.IsBatchProduct == "Auto"
              //   ) {
              //     return false;
              //   } else return true;
              // },
            },
            {
              screenField: "FXLineTotal",
              gridLabel: `Ex Total (${this.dataModel.SupplierCurrencyCode})`,
              gridDataField: "ExFXTotal",
              format: "Decimal-16-2C",
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
            },
            {
              screenField: "TaxFXTotal",
              gridLabel: `Tax (${this.dataModel.SupplierCurrencyCode})`,
              format: "Decimal-16-2C",
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
            },
            {
              screenField: "IncTaxFXTotal",
              gridLabel: `Inc Total (${this.dataModel.SupplierCurrencyCode})`,
              format: "Decimal-16-2C",
              width: ColumnWidth.Price2DecimalPoints.width,
              maxWidth: ColumnWidth.Price2DecimalPoints.minWidth,
            },
            {
              screenField: "Comments",
              dataField: "PurchaseOrderComment",
              width: 400,
              minWidth: 400,
              // cellTemplate: "ScrollView",
              cssClass: "grid-text-scroll comment-text",
              label: "PO Comment",
              customizeText: (e) => {
                if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
                else return "";
              },
              encodeHtml: false,
              cellTemplate: (data, info) => {
                return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
              },
            },
            {
              screenField: "Comments",
              dataField: "Comment",
              width: 400,
              minWidth: 400,
              // cellTemplate: "ScrollView",
              cssClass: "grid-text-scroll comment-text",
              label: "Goods In Comment",
              customizeText: (e) => {
                if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
                else return "";
              },
              encodeHtml: false,
              cellTemplate: (data, info) => {
                return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
              },
            },
            {
              screenField: "IsDefault",
              gridDataField: "Completed",
              label: "",
              cellTemplate: "CheckBoxTemplate",
              width: ColumnWidth.CheckBoxColumn.width,
              minWidth: ColumnWidth.CheckBoxColumn.minWidth,
              cssClass: "column-checkBox",
              allowSorting: false,
              allowSearch: false,
              makeReadOnly: () => {
                return true;
              },
              headerCellTemplate: "HeaderCheckBoxTemplate",
              defaultValue: false,
            },
            // {
            //   screenField: "GridRecordEllipsisMenu",
            //   allowEditing: false,
            //   showInColumnChooser: false,
            //   allowSorting: false,
            //   allowSearch: false,
            //   cssClass: "padding-7",
            // },
          ],

          ellipsisColumn: {
            items: [
              {
                label: "Line Comment",
                clickAction: "lineComment",
              },
            ],
            keyExpr: "label",
            displayExpr: "label",
            formItems: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    dataField: "Comment",
                    label: { text: "Comment", visible: false },
                    editorType: "dxTextArea",
                    editorOptions: {
                      maxLength: 100,
                      height: 140,
                    },
                  },
                ],
              },
            ],
          },
        },
        footerData: {
          footerItems: [
            {
              screenField: "Quantity",
              dataField: "SupplierReceivedQty",
              location: "left",
              label: "Item Count",
              value: 0,
              format: "Decimal-16-0",
            },
            {
              screenField: "SalesUMItemCount",
              dataField: "SupplierRequired",
              location: "left",
              label: "Line Count",
              value: 0,
              customCalc: (headerData, gridItems) => {
                return gridItems.length;
              },
            },
            {
              dataField: "ExFXTotal",
              screenField: "TaxableFXTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-2C",
              label: `Sub Total (${this.dataModel.SupplierCurrencyCode})`,
            },
            {
              screenField: "TaxFXTotal",
              dataField: "TaxFXTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-2C",
              label: `Tax (${this.dataModel.SupplierCurrencyCode})`,
            },
            {
              screenField: "FXTotal",
              dataField: "IncTaxFXTotal",
              location: "right",
              value: 0,
              format: "Decimal-16-2C",
              label: `Total (${this.dataModel.SupplierCurrencyCode})`,
            },
          ],
        },
      };
    },
    backButtonRoute() {
      return "/goods-in-review";
    },
    getLabel() {
      return this.expandChildGrid ? "Collapse" : "Expand";
    },
  },
  methods: {
    onEditorPreparing(e) {
      if (
        e.dataField &&
        (e.dataField == "PurchaseOrderComment" || e.dataField == "Comment")
      ) {
        e.editorName = "dxTextArea";
      }
    },
    getChildColumns(data) {
      let item = data.data;

      let visibleUseBy = true;
      let visibleBestBefore = true;
      let changeWidth = 0;

      if (
        item.Product.UseByShelfLife === -1 &&
        item.Product.BestBeforeShelfLife === -1
      ) {
        visibleUseBy = false;
        visibleBestBefore = false;
        // changeWidth = ColumnWidth.Date.width / 2;
      } else if (
        item.Product.UseByShelfLife > -1 &&
        item.Product.BestBeforeShelfLife > -1
      ) {
        visibleBestBefore = false;
      } else if (
        item.Product.UseByShelfLife > -1
        // && item.Product.BestBeforeShelfLife != -1
      ) {
        visibleBestBefore = false;
      } else if (
        item.Product.BestBeforeShelfLife > -1
        // && item.Product.UseByShelfLife != -1
      ) {
        visibleUseBy = false;
      }

      return [
        {
          screenField: "Batch",
          gridDataField: "BatchNo",
          allowEditing: false,
          showEditorAlways: false,
          width: ColumnWidth.BatchNo.width + 234 + changeWidth,
          minWidth: ColumnWidth.BatchNo.minWidth + 234 + changeWidth,
        },
        {
          screenField: "SupplierBatchNo",
          width: ColumnWidth.SupplierBatchNo.width + 234 + changeWidth,
          minWidth: ColumnWidth.SupplierBatchNo.minWidth + 234 + changeWidth,
        },
        {
          screenField: "Quantity",
          dataField: "SupplierOutstandingQuantity",
          format: "Decimal-16-4",
          label: "Outstanding",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity4DecimalPoints.maxWidth,
        },
        {
          screenField: "Quantity",
          dataField: "ReceivedQty",
          type: "EditableDecimal",
          showEditorAlways: false,
          format: "Decimal-16-2",
          label: "Received",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity4DecimalPoints.maxWidth,
        },
        {
          screenField: "DateIn",
          label: "Manufactured Date",
          gridDataField: "ManufacturedDate",
          allowEditing: false,
          allowSearch: false,
          allowFiltering: false,
          // cellTemplate: "Date",
          editable: false,
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
        },
        {
          screenField: "UseByDate",
          allowEditing: false,
          allowSearch: false,
          allowFiltering: false,
          // cellTemplate: "Date",
          editable: false,
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          visible: visibleUseBy,
        },
        {
          screenField: "BestBeforeDate",
          allowEditing: false,
          allowSearch: false,
          allowFiltering: false,
          // cellTemplate: "Date",
          editable: false,
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          visible: visibleBestBefore,
        },
      ];
    },
    onCollapseBtnContentReady(e) {
      this.CollapseBtnContentReady = e;
    },
    onContentReadyCallBack() {
      if (this.gridDataLoaded === false) {
        this.gridDataLoaded = true;
        setTimeout(() => {
          this.expandMasterDetailsSection();
        }, 500);
      }
    },
    expandMasterDetailsSection() {
      let gridInstance =
        this.$refs["goods-in-review"].$refs.transactionGrid.getGridInstance();
      let items = gridInstance.getDataSource().items();
      if (this.expandChildGrid) {
        this.expandChildGrid = false;
        items.forEach((element, index) => {
          if (element.ChildDataSource && element.ChildDataSource.length > 0) {
            setTimeout(() => {
              gridInstance.collapseRow(element);
            }, 100 * index);
          }
        });
      } else {
        this.expandChildGrid = true;
        items.forEach((element, index) => {
          if (element.ChildDataSource && element.ChildDataSource.length > 0) {
            setTimeout(() => {
              gridInstance.expandRow(element);
            }, 150 * index);
          }
        });
      }
      setTimeout(() => {
        gridInstance.refresh(true).then(() => {
          if (this.CollapseBtnContentReady) {
            this.CollapseBtnContentReady.component.beginUpdate();
            this.CollapseBtnContentReady.component.option(
              "text",
              this.getLabel,
            );
            this.CollapseBtnContentReady.component.option(
              "icon",
              this.expandChildGrid ? "chevronup" : "chevrondown",
            );
            this.CollapseBtnContentReady.component.endUpdate();
          }
        });
      }, 500);
    },
    onCellPreparedCallBack(e) {
      if (e.rowType === "data" || e.rowType === "header") {
        const self = this;

        if (e.column.dataField === "Completed") {
          on(e.cellElement, "mouseover", (arg) => {
            self.$refs[this.CompleteTooltipRefName].instance.show(arg.target);
          });

          on(e.cellElement, "mouseout", () => {
            self.$refs[this.CompleteTooltipRefName].instance.hide();
          });
        }
      }
    },
    toReturn(e) {
      if (e.event)
        this.$router.push({
          path: `/goods-return/edit/` + this.baseView.id,
          query: {
            redirect: "/goods-in-review/review/" + +this.baseView.id,
          },
        });
    },

    goToSupplierInvoice(e) {
      if (e.event)
        this.$router.push({
          path: "/supplier-invoice/create/" + this.dataModel.PurchaseOrderCode,
          query: {
            from: "goods-in-review/review/" + this.baseView.id,
          },
        });
    },
    async markAsComplete() {
      const confirmed = await this.$confirm(
        "Are you sure you want to Complete this Goods In and reverse the Accrual?",
        "Confirmation",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      );
      if (!confirmed) return;
      try {
        this.setLoading = true;
        await GoodsInReviewService.completeGoodsIn(this.baseView.id);
        this.$notify(
          "Goods In marked as Completed. Accrual reversal journal processed.",
          "success"
        );
        await this.initialized();
      } catch (error) {
        this.serverError = error;
      }
    },
    async initialized() {
      await GoodsInReviewService.getGoodsInByCode(this.baseView.id).then(
        (response) => {
          this.dataModel.DateIn = response.data.value[0].DateIn;
          this.dataModel.DateReceived = response.data.value[0].DateReceived;
          this.dataModel.SupplierName = response.data.value[0].Supplier.Name;
          this.dataModel.DateChanged = response.data.value[0].DateReceived;
          this.dataModel.DateCreated = response.data.value[0].DateIn;
          this.dataModel.ChangedBy = response.data.value[0].CreatedBy;
          this.dataModel.CreatedBy = response.data.value[0].CreatedBy;
          this.dataModel.Status = response.data.value[0].FriendlyStatus;
          this.dataModel.Note = response.data.value[0].Note;
          this.dataModel.FriendlyStatus = response.data.value[0].FriendlyStatus;
          this.dataModel.SupplierCurrencyCode =
            response.data.value[0].Supplier.CurrencyCode;
        },
      );
      await GoodsInReviewService.getGoodsInDetailByCode(this.baseView.id).then(
        (response) => {
          response.data.value.forEach((element) => {
            if (element.ReceivedQty < 0 && !this.isReturnedGoods) {
              this.isReturnedGoods = true;
            }
          });
          this.dataModel.PurchaseOrderCode =
            response.data.value[0].PurchaseOrderCode;
          this.dataModel.Name = `Goods In # ${this.baseView.id} for PO # ${this.dataModel.PurchaseOrderCode}`;
          this.dataModel.PurchaseOrder =
            response.data.value[0].PurchaseOrderCode;
          this.dataModel.GoodsInCode = this.baseView.id;
        },
      );

      this.setLoading = false;
      this.loaded = true;
    },
    PostProcess(data) {
      // this.data.Code=data.Code,
      data.forEach((element) => {
        if (element["PurchaseDescription"])
          element["ItemDescription"] = element["PurchaseDescription"];

        element["Completed"] = element["LineComplete"] == "Y" ? true : false;
        if (element["IsBatchProduct"] != "No") {
          this.IsBatchAvailable = true;
          GoodsInReviewService.getGoodsInBatches(
            element["GoodsInCode"],
            element["LineNo"],
          ).then((response) => {
            element["ChildDataSource"] = response.data.value;
            element.ChildDataSource.forEach((x) => {
              x.SupplierOutstandingQuantity = element.OutstandingQty;
              x.UseByShelfLife = element.Product.UseByShelfLife;
              x.BestBeforeShelfLife = element.Product.BestBeforeShelfLife;

              if (x.ManufacturedDate)
                x.ManufacturedDate = new Date(x.ManufacturedDate);
              if (x.UseByDate) x.UseByDate = new Date(x.UseByDate);
              if (x.BestBeforeDate)
                x.BestBeforeDate = new Date(x.BestBeforeDate);
            });
          });
        }

        element["ExFXTotal"] = (
          element.SupplierReceivedQty * element.SupplierFXPrice
        ).roundNumber(2);
        if (Number(element.TaxRate) !== 0) {
          element["TaxFXTotal"] = (
            element.SupplierReceivedQty *
            element.SupplierFXPrice *
            (1 / element.TaxRate)
          ).roundNumber(2);

          element["IncTaxFXTotal"] = (
            element.SupplierReceivedQty * element.SupplierFXPrice +
            element.SupplierReceivedQty *
              element.SupplierFXPrice *
              (1 / element.TaxRate)
          ).roundNumber(2);
        } else {
          element["TaxFXTotal"] = 0;
          element["IncTaxFXTotal"] = (
            element.SupplierReceivedQty * element.SupplierFXPrice
          ).roundNumber(2);
        }
      });

      setTimeout(() => {
        this.updateCompleteColumnCheckBox(data);
      }, 500);

      return data;
    },

    updateCompleteColumnCheckBox(gridItems) {
      let count = 0;
      gridItems.forEach((element) => {
        if (element.Completed) count = count + 1;
      });

      setTimeout(() => {
        let value = false;
        if (count > 0 && count !== gridItems.length) {
          value = undefined;
        } else if (count === 0) {
          value = false;
        } else if (count === gridItems.length) {
          value = true;
        }

        this.$refs["goods-in-review"].$refs[
          "transactionGrid"
        ].updateHeaderCheckBox("Completed", value);
        this.$refs["goods-in-review"].$refs["transactionGrid"].gridRepaint();
      }, 100);
    },
  },
  watch: {
    IsBatchAvailable: {
      handler(val) {
        if (val && this.CollapseBtnContentReady) {
          this.CollapseBtnContentReady.component.beginUpdate();
          this.CollapseBtnContentReady.component.option("visible", true);
          this.CollapseBtnContentReady.component.endUpdate();
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.goods-in-review {
  .date-in-container {
    padding-right: 0px !important;
  }

  .date-in-container {
    padding-left: 0px !important;
  }

  .colps-expnd-btn {
    margin-left: 35px;
  }

  .dx-datebox input.dx-texteditor-input {
    font-size: 12px !important;
  }
  .dx-widget:not(.internal-grid)
    .dx-datagrid
    .dx-datagrid-content
    > .dx-datagrid-table
    tbody
    > .dx-row:not(.dx-master-detail-row)
    > td:not(.dx-validation-pending):not(.dx-datagrid-select-all):not(
      [role="columnheader"]
    ) {
    vertical-align: top !important;
  }
}
</style>
